import api from "./client"
import type { ClientProgress, WorkoutExercise } from "../types"

export async function getClientProgress(clientId: number): Promise<ClientProgress> {
  const res = await api.get<ClientProgress>(`/clients/${clientId}/progress`)
  return res.data
}

export async function getWorkoutExercises(workoutLogId: number): Promise<WorkoutExercise[]> {
  const res = await api.get<WorkoutExercise[]>(`/workout_logs/${workoutLogId}/exercises`)
  return res.data
}

export async function addWorkoutExercise(
  workoutLogId: number,
  data: Omit<WorkoutExercise, "id" | "exercise_name">,
): Promise<WorkoutExercise> {
  const res = await api.post<WorkoutExercise>(`/workout_logs/${workoutLogId}/exercises`, {
    workout_exercise: data,
  })
  return res.data
}

export async function updateWorkoutExercise(
  workoutLogId: number,
  id: number,
  data: Partial<WorkoutExercise>,
): Promise<WorkoutExercise> {
  const res = await api.patch<WorkoutExercise>(`/workout_logs/${workoutLogId}/exercises/${id}`, {
    workout_exercise: data,
  })
  return res.data
}

export async function deleteWorkoutExercise(workoutLogId: number, id: number): Promise<void> {
  await api.delete(`/workout_logs/${workoutLogId}/exercises/${id}`)
}
